export const cryptoPercentChange = (historical: any) => {
	const oldest = historical[0]
	const newest = historical[historical.length - 1] || oldest

	return (((Number(newest.price) - Number(oldest.price)) / Number(oldest.price)) * 100).toFixed(2)
}
